import type { GarageProperty } from "@App/apis/graphql/perimeterSearch/responses/garageProperty";
import type { Garage, Organization, PremiumService, Service } from "@App/types";
import { buildCallbackRequestUrl } from "@App/utils/callbackRequest";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

type CallbackRequestButtonProps = {
  organization: Organization | null;
  garage: Garage | null;
  service: Service | null;
  premiumServices: PremiumService[] | null;
  garageProperties: GarageProperty[] | null;
};

export const CallbackRequestButton: FunctionComponent<CallbackRequestButtonProps> = ({
  organization,
  garage,
  service,
  premiumServices,
  garageProperties,
}) => {
  const { t } = useTranslation();

  const openCallbackForm = () => {
    const url = buildCallbackRequestUrl({
      organization,
      garage,
      service,
      premiumServices,
      garageProperties,
    });
    window.open(url, "_blank", "noopener");
  };

  return (
    <button
      type="button"
      onClick={openCallbackForm}
      className="w-full sm:w-72 mt-5 px-8 py-2 border border-primary text-primary bg-white hover:bg-primary-50 rounded text-center font-bold font-serif cursor-pointer no-underline"
    >
      {t("booking.requestCallback")}
    </button>
  );
};
